package pl.michal_cyran.brand_hub.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.BtnLgStyle
import pl.michal_cyran.brand_hub.BtnPrimaryStyle
import pl.michal_cyran.brand_hub.BtnStyle
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun FeaturedButton(
    path: String,
    text: String,
    icon: @Composable () -> Unit,
) {
    val cm = ColorMode.current.toSitePalette()

    Link(
        path = path,
        modifier = BtnStyle.toModifier()
            .then(
                Modifier
                    .backgroundColor(cm.ctaButtonBg)
                    .color(cm.ctaButtonText)
            )
            .then(BtnLgStyle.toModifier())
    ) {
        Text(text)
        icon()
    }
}